module.exports = {
	"id": "LB",
	"name": "Lebanon",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": 0.004182,
			"8": 0.016728,
			"9": null,
			"10": null,
			"11": 0.029274,
			"12": 0.004182,
			"13": 0.012546,
			"14": 0.004182,
			"15": 0.008364,
			"16": 0.008364,
			"17": 0.025092,
			"18": 0.008364,
			"19": 0.016728,
			"20": 0.004182,
			"21": null,
			"22": 0.008364,
			"23": 0.004182,
			"24": 0.008364,
			"25": 0.004182,
			"26": 0.008364,
			"27": 0.008364,
			"28": 0.008364,
			"29": 0.016728,
			"30": 0.012546,
			"31": 0.108732,
			"32": 0.02091,
			"33": 0.046002,
			"34": 0.02091,
			"35": 0.008364,
			"36": 0.033456,
			"37": 0.012546,
			"38": 0.037638,
			"39": 0.029274,
			"40": 0.037638,
			"41": 0.016728,
			"42": 0.016728,
			"43": 0.154734,
			"44": 0.058548,
			"45": 0.046002,
			"46": 0.04182,
			"47": 0.075276,
			"48": 0.087822,
			"49": 1.15005,
			"50": 0.100368,
			"51": 0.322014,
			"52": 0.359652,
			"53": 17.242386,
			"54": 4.62111,
			"55": 0.133824,
			"56": 0.050184,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.016728,
			"4": 0.004182,
			"5": null,
			"6": 0.004182,
			"7": null,
			"8": 0.008364,
			"9": 0.004182,
			"10": 0.02091,
			"11": 0.004182,
			"12": 0.012546,
			"13": 0.004182,
			"14": 0.008364,
			"15": 0.008364,
			"16": 0.012546,
			"17": null,
			"18": null,
			"19": 0.004182,
			"20": null,
			"21": 0.012546,
			"22": 0.012546,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.012546,
			"30": 0.008364,
			"31": 0.008364,
			"32": 0.008364,
			"33": 0.008364,
			"34": 0.008364,
			"35": 0.029274,
			"36": 0.012546,
			"37": 0.016728,
			"38": 0.037638,
			"39": 0.04182,
			"40": 0.02091,
			"41": 0.04182,
			"42": 0.04182,
			"43": 0.112914,
			"44": 0.04182,
			"45": 0.175644,
			"46": 0.117096,
			"47": 0.384744,
			"48": 0.664938,
			"49": 4.135998,
			"50": 0.179826,
			"51": 0.004182,
			"52": null,
			"3.5": null,
			"3.6": 0.025092
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.016728,
			"37": 0.02091,
			"38": 0.138006,
			"39": 0.008364,
			"40": 0.284376,
			"41": 0.046002,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.008364
		},
		"safari": {
			"0": null,
			"4": 0.004182,
			"5": 0.033456,
			"6": 0.029274,
			"7": 0.092004,
			"8": 0.37638,
			"9": 0.497658,
			"10": 0.999498,
			"3.1": 0.004182,
			"3.2": null,
			"5.1": 0.112914,
			"6.1": 0.06273,
			"7.1": 0.016728,
			"9.1": 1.091502
		},
		"ios_saf": {
			"8": 0,
			"10": 9.43781814654,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.25433827831,
			"8.1-8.4": 0.469879192132,
			"9.0-9.2": 0.224162550375,
			"9.3": 3.41991583264
		},
		"android": {
			"3": 0,
			"4": 0.121020413437,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0151275516796,
			"4.1": 0.436537919897,
			"4.2-4.3": 1.09134479974,
			"4.4": 2.50252926357,
			"4.4.3-4.4.4": 2.52414005168
		},
		"ie": {
			"6": 0.00842763913043,
			"7": 0.0126414586957,
			"8": 0.741632243478,
			"9": 0.349747023913,
			"10": 0.324464106522,
			"11": 2.43980152826,
			"5.5": null
		},
		"op_mob": {
			"0": 0.13601516312,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00377819897555
		},
		"edge": {
			"12": 0.163098,
			"13": 0.37638,
			"14": 0.46002
		},
		"ie_mob": {
			"10": 0.0183553802817,
			"11": 0.0747326197183
		},
		"bb": {
			"7": 0.0305445,
			"10": null
		},
		"samsung": {
			"0": 8.994628
		},
		"and_uc": {
			"0": 2.909
		},
		"op_mini": {
			"0": 1.8325086379
		},
		"and_chr": {
			"0": 24.55659
		},
		"and_ff": {
			"0": 0.011636
		}
	},
	"total": 99.1156165
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/LB.json
 ** module id = 572
 ** module chunks = 0
 **/